import ServicioDeQueryDeUnItem from "../../isp.servicios.items/ServicioDeQueryDeUnItem";
import ComandoAPI from "./ComandoAPI";

export default class ComandoBuscarUnItem extends ComandoAPI {
    constructor() {
        super();
        this.servicio = new ServicioDeQueryDeUnItem();
    }
}
